// src/store/modules/user.js
import { setToken, removeToken, setUserInfo, removeUserInfo } from '@/utils/auth'
import { login, logout } from '@/api/auth'
import { getUserInfo } from '@/api/user'
import { clearApiCache, invalidateApiCacheByUrl } from '@/utils/apiCache'

let refreshUserInfoPromise = null

export default {
    namespaced: true,
    state: {
        token: '',
        userInfo: null
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USER_INFO(state, info) {
            state.userInfo = info
        }
    },
    actions: {
        // 修复 - 使用传入的loginForm参数而不是外部userInfo
        async login({ commit }, loginData) {
            const response = await login(loginData)
            clearApiCache()
            setToken(response.data.access)
            commit('SET_TOKEN', response.data.access)
            return response
        },
        /**
         * 拉取用户资料并写入 store + localStorage
         * @param {{ force?: boolean }} [options] force=true 时绕过任何缓存
         */
        async getUserInfo({ commit }, options = {}) {
            try {
                const response = await getUserInfo({
                    force: options.force === true,
                    skipApiCache: true,
                })
                const info = response?.data ?? response
                if (!info || (response?.code !== undefined && response.code !== 0)) {
                    const err = new Error(response?.msg || '获取用户信息失败')
                    err.response = { status: response?.code === 401 ? 401 : 400, data: response }
                    throw err
                }
                setUserInfo(info)
                commit('SET_USER_INFO', info)
                return response
            } catch (error) {
                console.error('获取用户信息失败:', error)
                if (error?.response?.status === 401) {
                    commit('SET_TOKEN', '')
                    commit('SET_USER_INFO', null)
                    removeToken()
                    removeUserInfo()
                }
                return Promise.reject(error)
            }
        },
        /** 实名/交易等变更后强制刷新资料（并发合并为一次请求） */
        async refreshUserInfo({ dispatch }) {
            if (refreshUserInfoPromise) return refreshUserInfoPromise

            invalidateApiCacheByUrl((key) =>
                /usersProfile|\/user\/equity|\/user\/gold|international-card/.test(key)
            )

            refreshUserInfoPromise = dispatch('getUserInfo', { force: true }).finally(() => {
                refreshUserInfoPromise = null
            })
            return refreshUserInfoPromise
        },
        // 退出登录
        logout({ commit }) {
            logout()
            return new Promise((resolve) => {
                clearApiCache()
                commit('SET_TOKEN', '')
                commit('SET_USER_INFO', null)
                removeToken()
                removeUserInfo()
                // 清除localStorage
                localStorage.clear()
                // 清除sessionStorage
                sessionStorage.clear()
                resolve()
            })
        }

    }
}
